module.exports = __webpack_public_path__ + "media/entities/2319-57e91e5a.png";